export class Slot {
  constructor(private readonly id: number, private readonly name: string) {}

  getId() {
    return this.id;
  }

  getName() {
    return this.name;
  }
}
